import styled from 'styled-components';
import Info from 'images/icons/Info.svg?react';

export const SInfo = styled(Info)`
    width: 1.4rem;
    cursor: pointer;
`;
